import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import AppSelect from '../../../../../../../../shared/AppSelect';
import { useAmbientDialogContext } from '../AmbientDialogContext';

const Months = () => {
  const { monthFrom, setMonthFrom, monthTo, setMonthTo, season, disabled } = useAmbientDialogContext();
  const { t } = useTranslation();
  const months = useMemo(() => {
    return [
      { value: '01', label: t("ambient:create.months.january") },
      { value: '02', label: t("ambient:create.months.february") },
      { value: '03', label: t("ambient:create.months.march") },
      { value: '04', label: t("ambient:create.months.april") },
      { value: '05', label: t("ambient:create.months.may") },
      { value: '06', label: t("ambient:create.months.june") },
      { value: '07', label: t("ambient:create.months.july") },
      { value: '08', label: t("ambient:create.months.august") },
      { value: '09', label: t("ambient:create.months.september") },
      { value: '10', label: t("ambient:create.months.october") },
      { value: '11', label: t("ambient:create.months.november") },
      { value: '12', label: t("ambient:create.months.december") }
    ];
  }, [t]);

  useEffect(() => {
    if (season === 'Estival') {
      setMonthFrom('10');
      setMonthTo('05')
    } else {
      setMonthFrom('04');
      setMonthTo('11');
    }
  }, [season, setMonthFrom, setMonthTo]);

  return (
    <>
      <p className="fs-7 text-center fw-bold mb-3">{t("ambient:create.input.month_from.label")}</p>
      <div className="row">
        <div className="col-6">
          <AppSelect
            ariaLabel={t("ambient:create.input.month_from.label")}
            disabled={disabled}
            onChange={setMonthFrom}
            options={months}
            value={monthFrom}
          />
        </div>
        <div className="col-6">
          <AppSelect
            ariaLabel={t("ambient:create.input.month_to.label")}
            disabled={disabled}
            onChange={setMonthTo}
            options={months}
            value={monthTo}
          />
        </div>
      </div>
    </>
  );
};

export default Months;
